<template>
  <vx-card title="Filter Room" class="mb-6">
    <form>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex flex-wrap focusHolder">
            <div class="sm:w-1/2 w-full p-1">
              <label class="vs-input--label w-full">Inventory</label>
              <v-select
              class="w-full"
              :options="inventoryTypeList"
              label="name"
              v-model="filter.inventory_id"
              :reduce="(item) => item.assets_id"
              ></v-select>
            </div>
            <div class="sm:w-1/2 w-full p-1">
              <vs-input
                label="Number Of Person"
                class="w-full"
                v-model="filter.number_of_person"
                data-vv-name="number_of_person"
              />
            </div>
          </div>
          <div class="flex flex-wrap focusHolder">
            <div class="sm:w-1/2 w-full p-1">
              <vs-input
                label="Suitable For"
                class="w-full"
                v-model="filter.tags"
              />
            </div>
            <div class="sm:w-1/2 w-full p-1">
              <vs-input class="w-full" label="Price" v-model="filter.price" />
              <div
                v-if="errors.has('Room.price')"
                style="color: red"
                class="invalid-feedback"
              >
                {{ errors.first("Room.price") }}
              </div>
            </div>
          </div>
          <!-- <div class="flex flex-wrap focusHolder">


            <!-- <vs-input
              label="Price Type"
              class="sm:w-1/2 w-full p-1"
              v-model="filter.price_type"
            /> -->
          <!-- </div> -->
        </div>
      </div>

      <div class="flex mt-2 justify-end">
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-search"
          class="mr-2"
          @click="filterRoom()"
        >
        </vs-button>
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-refresh-ccw"
          @click="resetFilterRoom()"
        >
        </vs-button>
      </div>
    </form>
  </vx-card>
</template>
<script>
import vSelect from 'vue-select'
import { roomInventory } from '@/mixins/Rooms/roomInventory.js'
export default {
  components: {
    vSelect
  },
  mixins: [roomInventory],
  data () {
    return {
      asset_types: 'Room',
      assets_id: null,
      category_id: '',
      filter: {
        name: '',
        inventory_type: null,
        number_of_person: '',
        tags: '',
        price: '',
        inventory_id:'',
        price_type: ''
      }
    }
  },
  created () {
    this.fetchingInventoryType()
  },
  methods: {
    resetFilterRoom () {
      Object.keys(this.filter).forEach((key) => {
        this.filter[key] = ''
      })
      this.$emit('resetFilter')

    },
    filterRoom () {
      const newArray = Object.keys(this.filter)
      const fiteredArray = newArray.filter((ele) => {

        return this.filter[ele]
      })
      if (fiteredArray.length) {
        this.$emit('filterObject', this.filter)
      } else {
        this.showSuccessMessage(
          'Error',
          'Atleast filter by one value',
          'danger'
        )
      }

      //   newArray.filter(ele,index=>ele.1!false)


    }
  }
}
</script>
